import * as React from "react";
import "./tab.scss";
import IconWrapper from "../Icon/IconWrapper";
import classNames = require("classnames");
import {isNullOrUndefined} from "util";

interface IProps {
	/**
	 * Tab icon name. Without it the label stands alone.
	 */
	icon?: string;
	/**
	 * Tab label.
	 */
	label: string;
	/**
	 * Tab identifier - unique in tab set.
	 */
	tabId: string;
	/**
	 * Id of selected tab.
	 */
	selectedTabId?: string;
	/**
	 * Indicates if tab is disabled.
	 */
	disabled?: boolean;
	/**
	 * On tab click handler.
	 */
	onClick?: (id: string) => void;
}

export default class Tab extends React.Component<IProps, {}> {

	constructor(props: IProps) {
		super(props);
		this.onClick = this.onClick.bind(this);
	}

	render() {

		const iconVariantFromProps = !(this.props.selectedTabId === this.props.tabId) || this.props.disabled ? "lighterBlue" :
			"blue";

		const classFromProps = classNames({
			"a-tab": true,
			"is-active": this.props.selectedTabId === this.props.tabId,
			"is-disabled": this.props.disabled,
			"is-without-icon": !this.props.icon
		});

		return (
			<div className={classFromProps} onClick={() => this.onClick(this.props.tabId)}>
				<div className={"a-tab_label"}>
					{this.props.icon && <IconWrapper icon={this.props.icon} size={18}
													 disabled={this.props.disabled}
													 variant={iconVariantFromProps}/>}
					{this.props.label}
				</div>
				{this.props.children}
			</div>
		);
	}

	onClick(tabId: string) {
		if (!isNullOrUndefined(this.props.onClick)) {
			this.props.onClick(tabId);
		}
	}
}
